<template>
	<div ref="bookerTarget" class="choose-car">
		<div class="choose-car__container">
			<h2 v-if="!noTitle" :data-aos="disableAos ? undefined : 'fade-up'" class="choose-car__title">
				{{ $t('modules.home_page_module.home_page_choose_car.choose_vehicle') }}
			</h2>

			<div class="choose-car__main">
				<div v-if="!oneGroup" class="choose-car__segments">
					<ButtonCustom
						v-for="(group, i) in groups"
						v-show="i < 8"
						:key="i"
						class="choose-car__segment-btn"
						:class="{ 'choose-car__segment-btn--active': group.id === choosenGroup?.id }"
						@click="chooseGroup(group)">
						{{
							typeof group.name === 'string'
								? groupMap[group.name]
									? i18nService.$tDynamic('data.group_map_translations', groupMapTranslations[group.name])
									: group.name
								: group.name
						}}
					</ButtonCustom>
				</div>

				<Swiper
					class="choose-car__swiper"
					slidesPerView="auto"
					:space-between="16"
					@after-init="
						(swiper) => {
							// PAGE TRANSITION MODE OUT-IN FIX
							useTimeoutFn(() => {
								swiper.slideNext(0)
								swiper.slidePrev(0)
							}, 400)
						}
					"
					@slide-change="closeTooltipsOnEachSingleCarRef()">
					<SwiperSlide v-for="(car, j) in cars" v-show="cars && cars?.length" :key="j" class="choose-car__swiper-slide">
						<CarsSingleCar
							ref="singleCarRefs"
							:car="car"
							home
							:whiteCard="whiteCard"
							:modal-form="props.modalForm"
							:min-months="props.minMonths"
							:max-months="props.maxMonths"
							:noBooker="props.noBooker" />
					</SwiperSlide>
					<SwiperSlide
						v-for="k in 10"
						v-show="!cars || cars?.length < 1"
						:key="k"
						:slidesPerView="4"
						:space-between="16"
						class="choose-car__swiper-slide">
						<Skeletor class="choose-car__skeletor" round :height="497" />
					</SwiperSlide>

					<GlobalNewsSwiperNav v-if="cars && cars?.length" :gray-bg="props.grayBg" />
					<GlobalNewsSwiperNav v-else :gray-bg="props.grayBg" />
				</Swiper>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Skeletor } from 'vue-skeletor'
// import { format } from 'date-fns'

const props = defineProps<{
	modalForm?: boolean
	minMonths?: number
	maxMonths?: number
	grayBg?: boolean
	noTitle?: boolean
	whiteCard?: boolean
	oneGroup?: EGroupName
	disableAos?: boolean
	init?: boolean
	noBooker?: boolean
}>()

const singleCarRefs = ref<HTMLElement[]>([])

const closeTooltipsOnEachSingleCarRef = () => {
	singleCarRefs.value.forEach((ref: any) => {
		if (ref?.changeTooltip) {
			ref.changeTooltip(false)
		}
	})
}

const groups = ref<IProductGroupModel[]>([])
const choosenGroup = ref<IProductGroupModel | null>(null)
const cars = ref<IProductModel[]>([])
const bookerTarget = inject<HTMLElement>('bookerTarget')
const i18nService = usei18nService()
// const bookerStore = useBookerStore()
const carsStore = useCarsStore()

const fetchGroups = async () => {
	try {
		const response = await carsStore.fetchAllGroups()
		groups.value = response

		if (props.oneGroup) {
			choosenGroup.value = groups.value.find((group) => group.name === props.oneGroup) || null
		} else {
			choosenGroup.value = groups.value[0]
		}
		return response
	} catch (error) {
		console.error(error)
	}
}

if (props?.init) {
	await fetchGroups()
}

const fetchCars = async () => {
	try {
		if (!choosenGroup.value) return
		cars.value = []

		const searches: IProductParameterSearch[] = [
			{
				id: 'group_id',
				values: [choosenGroup.value.id],
			},
		]

		const filters: IProductFilter[] = []

		filters.push({
			id: 'has_price',
			value: '1',
		})

		const response = await ApiService.fetchProductsByParameters(searches, filters)

		cars.value = response.response
		return response
	} catch (error) {
		console.error(error)
	}
}

const initSection = async () => {
	await fetchGroups()
	await fetchCars()
}

const chooseGroup = (group: IProductGroupModel) => {
	choosenGroup.value = group
	fetchCars()
}

onMounted(() => {
	initSection()
})
</script>

<style lang="scss">
@import 'vue-skeletor/dist/vue-skeletor.css';
@import './HomePageChooseCar';
</style>
